"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelContainerStyleName = exports.ContentContainerStyleName = exports.ChevronContainerStyleName = exports.TreeItemStyleName = exports.SeparatorStyleName = exports.SectionTitleStyleName = exports.TreeStyleName = exports.CheckContainerStyleName = exports.SpinnerWrapperStyleName = exports.SearchFieldStyleName = exports.RootContainerStyleName = exports.CheckIconSize = exports.DefaultIconSize = exports.TreeNodeLevelCSSVarName = exports.TreeHeightCSSVarName = exports.TreeUnselectableParentsClassName = exports.TreeNodeLoadingClassName = exports.TreeNodeDisabledClassName = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("../../styles/Colors");
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var ListStyles_1 = require("../List/ListStyles");
exports.TreeNodeDisabledClassName = 'disabled';
exports.TreeNodeLoadingClassName = 'loading';
exports.TreeUnselectableParentsClassName = 'unselectable-parents';
exports.TreeHeightCSSVarName = '--tree-height';
exports.TreeNodeLevelCSSVarName = '--tree-node-level';
exports.DefaultIconSize = 14;
exports.CheckIconSize = 12; // check icon with surrounding border should appear as same size as other icons
var ChevronContainerSize = 24; // touch and pointer target size is bigger than the default icon size for better usability
var SpacingAroundIcons = (ChevronContainerSize - exports.DefaultIconSize) / 2;
var MinWidthForContent = 100; // ensure some space for the label container since (24 + 14) pixels are reserved for the chevron and the check
var TreeIndentPixelsCSSVarName = '--tree-indent-pixels';
var TreeItemCheckboxMarginCSSVarName = '--treeitem-checkbox-margin';
exports.RootContainerStyleName = TypeStyle.style((_a = {},
    _a[TreeIndentPixelsCSSVarName] = ChevronContainerSize - SpacingAroundIcons,
    _a[TreeItemCheckboxMarginCSSVarName] = 0,
    _a.display = 'flex',
    _a.flexDirection = 'column',
    _a));
exports.SearchFieldStyleName = TypeStyle.style({
    flexShrink: 0,
    marginLeft: 3,
    marginRight: 3,
    marginTop: 3,
    $nest: {
        '& input': {
            width: '100%',
        },
    },
});
exports.SpinnerWrapperStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'inline-flex',
    height: '100%',
    justifyContent: 'center',
    overflowY: 'hidden',
    width: '100%',
});
exports.CheckContainerStyleName = TypeStyle.style({
    border: "1px solid transparent",
    borderRadius: 2,
    display: 'inline-flex',
    flexShrink: 0,
    margin: "var(" + TreeItemCheckboxMarginCSSVarName + ")",
    height: exports.CheckIconSize,
    width: exports.CheckIconSize,
});
var loadingTreeItem = "[role=\"treeitem\"]." + exports.TreeNodeLoadingClassName;
var selectedTreeItem = '[role="treeitem"][aria-selected="true"]';
var enabled = ":not(." + exports.TreeNodeDisabledClassName + ", [aria-disabled=\"true\"])";
var selectedEnabledTreeItem = "" + selectedTreeItem + enabled;
exports.TreeStyleName = TypeStyle.style({
    color: Colors_1.TextColors.Primary,
    flexGrow: 1,
    fontSize: 12,
    listStyle: 'none',
    margin: 0,
    overflow: 'auto',
    padding: ListStyles_1.ListAndMenuPadding,
    $nest: (_b = {},
        _b["&[aria-multiselectable=\"true\"] ." + exports.CheckContainerStyleName] = {
            borderColor: 'currentcolor',
            order: -1,
        },
        _b["&." + exports.TreeUnselectableParentsClassName + "[aria-multiselectable=\"true\"] [role=\"treeitem\"][aria-expanded] ." + exports.CheckContainerStyleName + ",\n      &[aria-multiselectable=\"true\"] " + loadingTreeItem + " ." + exports.CheckContainerStyleName] = {
            borderColor: 'transparent',
        },
        _b["&." + exports.TreeUnselectableParentsClassName + "[aria-multiselectable=\"true\"] ." + exports.CheckContainerStyleName + ",\n      &[aria-multiselectable=\"true\"] " + loadingTreeItem + " ." + exports.CheckContainerStyleName] = {
            marginLeft: -(exports.DefaultIconSize + SpacingAroundIcons),
        },
        _b['& ul'] = {
            listStyle: 'none',
            margin: 0,
            paddingLeft: 0,
        },
        _b['&:focus-visible'] = FocusIndicators_1.DefaultFocusIndicator(),
        _b["&:focus-visible " + selectedTreeItem + ", :focus-within > & " + selectedTreeItem + ", &." + ListStyles_1.ListIsActiveClass + " " + selectedTreeItem] = {
            borderColor: Colors_1.ListAndMenuColors.ActiveBorder,
        },
        _b["&:focus-visible " + selectedEnabledTreeItem + ", :focus-within > & " + selectedEnabledTreeItem + ", &." + ListStyles_1.ListIsActiveClass + " " + selectedEnabledTreeItem] = {
            backgroundColor: Colors_1.ListAndMenuColors.Hover,
        },
        _b)
});
exports.SectionTitleStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { alignItems: 'center', display: 'flex', fontWeight: 'bold', minHeight: ListStyles_1.ListAndMenuItemHeight, paddingLeft: "calc(var(" + exports.TreeNodeLevelCSSVarName + ") * var(" + TreeIndentPixelsCSSVarName + ") + " + SpacingAroundIcons + "px)" }));
exports.SeparatorStyleName = TypeStyle.style({
    background: '#C9C9C9',
    height: 1,
    marginBottom: 8,
    marginLeft: "calc(var(" + exports.TreeNodeLevelCSSVarName + ") * var(" + TreeIndentPixelsCSSVarName + "))",
    marginTop: 8,
    minWidth: "calc((var(" + exports.TreeHeightCSSVarName + ") - var(" + exports.TreeNodeLevelCSSVarName + ")) * var(" + TreeIndentPixelsCSSVarName + ") + " + MinWidthForContent + "px)",
});
exports.TreeItemStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { alignItems: 'center', border: '1px solid transparent', borderRadius: 2, boxSizing: 'border-box', display: 'flex', minHeight: ListStyles_1.ListAndMenuItemHeight, minWidth: "calc(var(" + exports.TreeHeightCSSVarName + ") * var(" + TreeIndentPixelsCSSVarName + ") + " + MinWidthForContent + "px)", paddingLeft: "calc(var(" + exports.TreeNodeLevelCSSVarName + ") * var(" + TreeIndentPixelsCSSVarName + "))", $nest: (_c = {},
        _c["&:hover" + enabled] = {
            backgroundColor: Colors_1.ListAndMenuColors.Hover,
            borderColor: Colors_1.ListAndMenuColors.ActiveBorder,
        },
        _c["&&:active" + enabled] = {
            backgroundColor: Colors_1.ListAndMenuColors.Press,
            borderColor: Colors_1.ListAndMenuColors.ActiveBorder,
        },
        _c) }));
exports.ChevronContainerStyleName = TypeStyle.style({
    display: 'inline-flex',
    flexShrink: 0,
    height: ChevronContainerSize,
    width: ChevronContainerSize,
    $nest: {
        '& svg': {
            cursor: 'pointer',
            padding: SpacingAroundIcons,
        },
        '[aria-expanded="true"] > & svg': {
            transform: 'rotate(90deg)',
        },
    }
});
exports.ContentContainerStyleName = TypeStyle.style({
    display: 'inline-flex',
    flexGrow: 1,
    gap: SpacingAroundIcons,
    paddingBottom: SpacingAroundIcons,
    paddingRight: SpacingAroundIcons,
    paddingTop: SpacingAroundIcons,
    $nest: (_d = {},
        _d["." + exports.TreeNodeDisabledClassName + " > &"] = {
            color: Colors_1.TextColors.Disabled,
        },
        _d)
});
exports.LabelContainerStyleName = TypeStyle.style({
    display: 'inline-flex',
    flexGrow: 1,
    wordBreak: 'break-word', // in case the text is very long without any spaces
});
//# sourceMappingURL=TreeStyles.js.map